"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

var _reactRedux = require("react-redux");

var _payments = require("../../redux/modules/payments");

var _address = require("../../redux/modules/address");

var _customer = require("../../redux/modules/customer");

var _components = require("components");

var _AddressAndPaymentSettingForum = require("./AddressAndPaymentSettingForum");

var _AddressAndPaymentSettingForum2 = _interopRequireDefault(_AddressAndPaymentSettingForum);

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _utils = require("../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaymentsAndSettingsPopup = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(PaymentsAndSettingsPopup, _React$Component);

  function PaymentsAndSettingsPopup(props) {
    (0, _classCallCheck3.default)(this, PaymentsAndSettingsPopup);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PaymentsAndSettingsPopup.__proto__ || (0, _getPrototypeOf2.default)(PaymentsAndSettingsPopup)).call(this, props));

    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handlePayPalPrepare = _this.handlePayPalPrepare.bind(_this);
    _this.setPayPalState = _this.setPayPalState.bind(_this);
    _this.setCreditCardState = _this.setCreditCardState.bind(_this);
    _this.handleCaptchaChange = _this.handleCaptchaChange.bind(_this);
    _this.handleCreditCardPrepare = _this.handleCreditCardPrepare.bind(_this);

    _this.state = {
      message: null,
      paymentType: "",
      paypalPrepared: false,
      _error: null
    };
    return _this;
  }

  (0, _createClass3.default)(PaymentsAndSettingsPopup, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.props.getCustomer();
      this.props.getNextBillingPrice();
      this.props.resetPostalCode();
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (this.state.paymentType !== nextState.paymentType) {
        this.setState({
          paypalPrepared: false
        });
        return true;
      }
      if (this.state.message !== nextState.message) {
        return true;
      }
      if (this.state._error !== nextState._error) {
        return true;
      }
      if (this.props.customer.updating !== nextProps.customer.updating) {
        return true;
      }
      if (this.props.nonce !== nextProps.nonce) {
        return true;
      }
      if (this.props.customer.updateError !== nextProps.customer.updateError) {
        this.setState({
          _error: nextProps.customer.updateError.msg
        });
        return true;
      }
      if (this.props.clientToken !== nextProps.clientToken) {
        return true;
      }
      if (this.props.nextBillingPrice.loading !== nextProps.nextBillingPrice.loading) {
        return true;
      }
      if (this.props.customer.error !== nextProps.customer.error) return true;
      if (this.props.customer.createError !== nextProps.customer.createError) return true;
      if (this.props.customer.creating !== nextProps.customer.creating) return true;
      if (this.props.paypalEmail !== nextProps.paypalEmail) {
        return true;
      }
      if (this.props.address !== nextProps.address) {
        return true;
      }
      return false;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _props = this.props,
          teardownPayment = _props.teardownPayment,
          resetPostalCode = _props.resetPostalCode;


      teardownPayment();
      resetPostalCode();
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(values) {
      var _this2 = this;

      this.setState({
        message: null,
        updating: true
      });

      var vat = this.props.vat[values.vatNo];
      if (vat) {
        if (vat["vatNo"]) {
          values.vatNo = vat.vatNo.replace(" ", "");
          values.vatSignature = vat.signature;
        }
      }

      setTimeout(function () {
        return _this2.props.updatePaymentMethod({
          values: values
        }).then(function (res) {
          _this2.setState({
            message: res.type ? "Successfully updated payment settings" : res.isError ? res.msg : "Successfully updated payment settings"
          });
        }).catch(function (e) {
          console.log(e);
        });
      }, 2000);
    }
  }, {
    key: "handlePayPalPrepare",
    value: function handlePayPalPrepare() {
      var singleUse = false;
      var amount = 0;
      var currency = "USD";
      this.props.paypalNonce({
        container: "paypal-container",
        singleUse: singleUse,
        amount: amount,
        currency: currency
      });
    }
  }, {
    key: "handleCaptchaChange",
    value: function handleCaptchaChange(value) {
      var paymentType = this.state.paymentType;


      if (value && paymentType === "pay-pal") {
        this.handlePayPalPrepare();
      } else if (value && paymentType === "cc") {
        //Plus check if  nonce is  present or not
        this.handleCreditCardPrepare();
      }
    }
  }, {
    key: "handleCreditCardPrepare",
    value: function handleCreditCardPrepare() {
      // Skip re-rendering of credit card fields, if captcha got expire.
      var elem = document.getElementById("braintree-hosted-field-number");
      if (!elem) {
        this.props.creditCardNonce();
      }
    }
  }, {
    key: "setCreditCardState",
    value: function setCreditCardState() {
      this.setState({
        paymentType: "cc"
      });
    }
  }, {
    key: "setPayPalState",
    value: function setPayPalState() {
      this.setState({
        paymentType: "pay-pal"
      });

      this.handlePayPalPrepare();
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          _props2$customer = _props2.customer,
          customer = _props2$customer.customer,
          updating = _props2$customer.updating,
          createError = _props2$customer.createError,
          creating = _props2$customer.creating,
          nonce = _props2.nonce,
          clientToken = _props2.clientToken,
          onCancelSubscriptionClick = _props2.onCancelSubscriptionClick,
          nextBillingPrice = _props2.nextBillingPrice,
          user = _props2.user,
          paypalEmail = _props2.paypalEmail;


      var initialValues = { country: "US", paymentMethod: "cc" };
      var nextCharge = null;
      var existingMethod = null;

      var isUnrealUnlimited = user.subscription && user.subscription.planId === "unreal-unlimited";

      if (customer) {
        var paypal = customer.paymentMethod.paymentMethodInstrument === "paypal" && customer.paymentMethod.email ? customer.paymentMethod.email : null;
        var creditCard = customer.paymentMethod.last4;

        existingMethod = paypal ? "Paypal (" + paypal + ")" : "Credit Card (**** **** **** " + creditCard + ")";

        var subscription = user.subscription;

        var _ref = subscription || {},
            expiresAt = _ref.expiresAt;

        if (expiresAt && (0, _moment2.default)(expiresAt).isAfter((0, _moment2.default)()) && nextBillingPrice && nextBillingPrice.price) {
          if (nextBillingPrice.vatAmount && nextBillingPrice.vatAmount > 0) {
            nextCharge = "You will be charged $" + nextBillingPrice.price + " ($" + nextBillingPrice.priceExcludingTax + " fee + $" + nextBillingPrice.vatAmount + " tax) on your next billing date, " + (0, _moment2.default)(expiresAt).format("MMMM DD, YYYY") + ".";
          } else {
            nextCharge = "You will be charged $" + nextBillingPrice.price + " on your next billing date, " + (0, _moment2.default)(expiresAt).format("MMMM DD, YYYY") + ".";
          }
        }

        var paymentType = "cc";

        initialValues = customer ? customer.state ? {
          name: customer.name,
          company: customer.company,
          address: customer.address1,
          postalCode: customer.postalCode,
          city: customer.city,
          country: customer.countryCode,
          vatNo: customer.vatNo,
          state: customer.state,
          address2: customer.address2,
          paymentMethod: paymentType
        } : {
          name: customer.name,
          company: customer.company,
          address: customer.address1,
          postalCode: customer.postalCode,
          city: customer.city,
          country: customer.countryCode,
          vatNo: customer.vatNo,
          address2: customer.address2,
          paymentMethod: paymentType
        } : { country: "US", paymentMethod: paymentType };
      }

      return _react2.default.createElement(_AddressAndPaymentSettingForum2.default, {
        nextCharge: nextCharge,
        initialValues: initialValues,
        paypalContainerId: "paypal-container",
        updating: updating || creating,
        _error: this.state._error || createError && createError.msg,
        existingMethod: existingMethod,
        message: this.state.message,
        onPayPalPrepare: this.setPayPalState,
        paypalNonce: nonce,
        onSubmit: this.handleSubmit,
        paymentLogosSrc: "/icons/payment-icons.png",
        onCancelSubscriptionClick: !isUnrealUnlimited && onCancelSubscriptionClick,
        braintreeLink: "https://www.braintreegateway.com/merchants/2mgdr37qhn27xsmy/verified",
        renderCaptcha: function renderCaptcha(field) {
          return _react2.default.createElement(_components.Captcha, { field: field, onChange: _this3.handleCaptchaChange });
        },
        setCreditCardState: this.setCreditCardState,
        paypalPaymentBoxError: clientToken.error,
        creditCardPrepare: this.handleCreditCardPrepare,
        paypalEmail: paypalEmail,
        validatePostalCode: this.props.validatePostalCode,
        address: this.props.address
      });
    }
  }]);
  return PaymentsAndSettingsPopup;
}(_react2.default.Component), _class.contextTypes = {
  dialogs: _react2.default.PropTypes.object
}, _temp);
exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.user,
    customer: state.customer,
    userEmail: state.user.email,
    nonce: state.payments.currentPayment.nonce,
    deviceData: state.payments.currentPayment.deviceData,
    clientToken: state.payments.clientToken,
    nextBillingPrice: state.payments.nextBillingPrice,
    vat: state.vat,
    paypalEmail: state.payments.currentPayment.paypalEmail,
    address: state.address
  };
}, {
  getCustomer: _customer.getCustomer,
  initPayment: _payments.initPayment,
  getNextBillingPrice: _payments.getNextBillingPrice,
  updatePaymentMethod: _payments.updatePaymentMethod,
  paypalNonce: _payments.paypalNonce,
  teardownPayment: _payments.teardownPayment,
  updateCustomerAddress: _customer.updateCustomerAddress,
  createCustomer: _customer.createCustomer,
  creditCardNonce: _payments.creditCardNonce,
  validatePostalCode: _address.validatePostalCode,
  resetPostalCode: _address.resetPostalCode
})(PaymentsAndSettingsPopup);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PaymentsAndSettingsPopup/PaymentsAndSettingsPopup.js
// module id = 2532
// module chunks = 0